import * as React from 'react';
import PropTypes from 'prop-types';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
function ThirdFeaturedPost(props) {

  const { post, button } = props;
 const navigate = useNavigate()
  const handleClick = () => {
    
    navigate('/contact')

  }


  return(
<Paper
  sx={{
    position: 'relative',
    backgroundColor: 'grey.800',
    color: '#fff',
    mb: 4,
  }}
  
> 
  {/* Increase the priority of the hero background image */}
  {<img style={{ display: 'none' }} src={post.image} alt={post.imageText} />}
  <Box
    sx={{
      position: 'absolute',
      top: 0,
      bottom: 0,
      right: 0,
      left: 0,
      backgroundColor: 'rgba(0,0,0,.3)',
    }}
  />
  <Grid container>


    {/* Grid item for the text */}
    <Grid item md={6}>
      <Box
        sx={{
          position: 'relative',
          p: { xs: 3, md: 6 },
          pr: { md: 0 },
        }}
      >
        <Typography component="h1" sx={{fontWeight: 'bold',}} variant="h3" color="inherit" gutterBottom>
          {post.title}
        </Typography>
        <Typography variant="h5" color="inherit" paragraph>
          {post.description}
        </Typography>
        <Link variant="subtitle1" href="#">
          {post.linkText}
        </Link>
        { button==true ? <Button variant="contained" onClick={handleClick}>Contact Us</Button> : null }
      </Box>
    </Grid>
        {/* Grid item for the image */}
        <Grid item md={6} 
      sx={{
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundImage: `url(${post.image})`,
        height: '400px',  // make sure the image covers the entire height of the container
      }}
    />
    
  </Grid>

</Paper>


  )


  return (
    <Paper
      sx={{
        position: 'relative',
        backgroundColor: 'grey.800',
        color: '#fff',
        mb: 4,

        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundImage: `url(${post.image})`,
      }}
    >
      {/* Increase the priority of the hero background image */}
      {<img style={{ display: 'none' }} src={post.image} alt={post.imageText} />}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          bottom: 0,
          right: 0,
          left: 0,
          backgroundColor: 'rgba(0,0,0,.3)',
        }}
      />
      <Grid container>
        <Grid item md={6}>
          <Box
            sx={{
              position: 'relative',
              p: { xs: 3, md: 6 },
              pr: { md: 0 },
            }}
          >
            <Typography component="h1" sx={{fontWeight: 'bold',}} variant="h3" color="inherit" gutterBottom>
              {post.title}
            </Typography>
            <Typography variant="h5" color="inherit" paragraph>
              {post.description}
            </Typography>
          </Box>
        </Grid>



      </Grid>
    </Paper>
  );
}

ThirdFeaturedPost.propTypes = {
  post: PropTypes.shape({
    description: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    imageText: PropTypes.string.isRequired,
    linkText: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
};

export default ThirdFeaturedPost;
